export default {"src":"/_next/static/media/address-bottom.ecd55bfc.svg","height":6,"width":675,"blurWidth":0,"blurHeight":0};